import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import { getCookies } from 'actions/global';
import { changeHotel, getAllHotelData, getMainPageMeta } from 'actions/hotel';
import { getHomeNewsList } from 'actions/news';
import { getEachHotelAttractions } from 'actions/attraction';
import { getPopupIndex } from 'actions/popup';

import { createScroller } from 'util/event';
import { lanMapRoute } from 'util/i18n';
import { initGA, sendPageView } from 'util/analytics';

import AppContainer from './container';

import MainRoute from './Main';
import HotelRoute from './Hotel';
import NewsRoute from './News';
import PrivacyRoute from './Privacy';

const createRoutes = store => {
	const scroll = createScroller(store);

	return {
		path: '/',
		component: AppContainer,
		onEnter: ({ location: { pathname, search }}) => {
			scroll.addListener();
			initGA();
			sendPageView(pathname + search);
			store.dispatch(getAllHotelData());
			store.dispatch(getCookies());
		},
		onChange: (pre, { location: { pathname, search }}) => {
			sendPageView(pathname + search);
		},
		onLeave: () => {
			scroll.removeListener();
		},
		indexRoute: {
			getComponent: (nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./Home').default;
						cb(null, component);
					},
					'Home',
				),
			onEnter: () => {
				const {
					global: { lan },
					hotel: { hotel },
				} = store.getState();

				if (hotel !== 'main') {
					store.dispatch(changeHotel('main'));
				}

				store.dispatch(getHomeNewsList(lanMapRoute(lan), {}));
				store.dispatch(getPopupIndex(lanMapRoute(lan), {}));
				store.dispatch(getEachHotelAttractions(lanMapRoute(lan)));
				store.dispatch(getMainPageMeta('tw'));
			},
		},
		childRoutes: [MainRoute(store), NewsRoute(store), PrivacyRoute(store), HotelRoute(store)],
	};
};

const Routes = ({ store, history }) => (
	<Provider store={store}>
		<Router
			key={Math.random()}
			onUpdate={() => window.scrollTo(0, 0)}
			history={history}
			routes={createRoutes(store)}
		/>
	</Provider>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js